import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { getPaymentRules, savePaymentRule } from "../../services/admin/action";


class PaymentRules extends React.Component{
    constructor(props){
        super(props)
        this.state = {
         paymentRules :[]
        }
    }

    componentDidMount(){
 
         let access_token =  this.props.loginDetails;

        

          this.props.getPaymentRules(access_token)
    }

 

    componentWillReceiveProps = nextProps => {
       if(nextProps.getPaymentRulesStatus == true){
          let data = nextProps.getPaymentRulesDetails.paymentRulesList
         this.setState({
            paymentRules : data
         })
       }
     }
     editPaymentRule = (e,rule) =>{
      e.preventDefault();
          this.props.savePaymentRule(rule);
         this.props.history.push("/EditPaymentRules");

      }
      goBack=(e) =>{
         e.preventDefault();
         this.props.history.push("/AdminHome")
      }

    render(){
         return(
            <>

<Header status ={"afterLogin"} routes={[{"name" : "Home", "route" : "/AdminHome",},{"name" : "Payment Rules", "route" : "/PaymentRules",}]}  />

   <div className="content"> 
   <div className="contentSection" id="content">
      <div className="container-fluid">
        
         <div className="bodyContent">
            <div className="row">
               <div className="col-lg-8 col-md-8 col-xs-12">
                  <div className="payment_details">
                     <p>Please ensure that each state as appropriate rates as per regulations</p>
                  </div>
               </div>
               <div className="col-lg-4 col-md-4 col-xs-12">
                  <div className="payment_details_last_updated">
                     <p>Last updated : <span>Aug 31 2018</span> </p>
                  </div>
               </div>
            </div>
            <div className="row">
               <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                       <div className="table-responsive tableFixHead">
                  <table className="table commonTable table-bordered">
                  
                     <thead>
                        <tr>
                           <th>Edit</th>
                           <th className="fix-col">State</th>
                           <th className="fix-col">State Abbreviation</th>
                           <th>Allowed state on epaper road</th>
                           <th>Postage upcharge allowed?</th>
                           <th>Upcharge rate</th>
                           <th>Fedex / Mail Available</th>
                           <th>Search/ Handling  Fee</th>
                           <th>Search Fee Applies to Patient as Requestor</th>
                           <th>Maximum Fee (not including postage)</th>
                           <th>search fee includes 1-5</th>
                           <th>search fee includes 1-10</th>
                           <th>search fee includes 1-14</th>
                           <th>search fee includes 1-20</th>
                           <th>search fee includes 1-25</th>
                           <th>1 through 20</th>
                           <th>1 through 10</th>
                           <th>1 through 25</th>
                           <th>1 through 30</th>
                           <th>1 through 40</th>
                           <th>1 through 100</th>
                           <th>6 and over</th>
                           <th>11 and over</th>
                           <th>11 through 20</th>
                           <th>11 through 40</th>
                           <th>11 through 50</th>
                           <th>14 through 25</th>
                           <th>16 and over</th>
                           <th>21 through 50</th>
                           <th>21 through 60</th>
                           <th>21 through 100</th>
                           <th>26 through 50</th>
                           <th>26 through 100</th>
                           <th>26 through 350</th>
                           <th>26 and over</th>
                           <th>31 and over</th>
                           <th>41 and over</th>
                           <th>51 through 100</th>
                           <th>51 and over</th>
                           <th>61 and over</th>
                           <th>101 and over</th>
                           <th>351 and over</th>
                           <th>Regardless of the # of pages</th>
                          
                        </tr>
                     </thead>
                     <tbody >
            {this.state.paymentRules.length > 0 ?
               this.state.paymentRules.map((rule, id) =>{
                  return (
                         <tr key={id}>
                           <td> <a href="javascript:void(0)" onClick={(e) => this.editPaymentRule(e,rule)} className="icon" title="Edit"><i className="fa fa-pencil" aria-hidden="true"></i></a></td> 
                           <td className="fix-col"> {rule.state} </td>
                           <td> {rule.stateAbbreviation ? rule.stateAbbreviation : "" } </td>
                           <td> {rule.isAllowedState ? rule.isAllowedState : "" } </td>
                           <td> {rule.isPostageUpchargeAllowed ? rule.isPostageUpchargeAllowed : "" } </td>
                           <td> {rule.upChargeRate ? rule.upChargeRate : "" } </td>
                           <td> {rule.isFedexOrMailAvailable ? rule.isFedexOrMailAvailable : "" } </td>
                           <td> {rule.searchOrHandlingFee ? rule.searchOrHandlingFee : "" } </td>
                           <td> {rule.isSearchFeeToPatientAsRequestor ? rule.isSearchFeeToPatientAsRequestor : "" } </td>
                           <td> {rule.maximumFee ? rule.maximumFee : "" } </td>
                           <td> {rule.isSearchFeeOneToFive ? rule.isSearchFeeOneToFive : "" } </td>
                           <td> {rule.isSearchFeeOneToTen ? rule.isSearchFeeOneToTen : "" } </td>
                           <td> {rule.isSearchFeeOneToFourteen ? rule.isSearchFeeOneToFourteen : "" } </td>
                           <td> {rule.isSearchFeeOneToTwenty ? rule.isSearchFeeOneToTwenty : "" } </td>
                           <td> {rule.isSearchFeeOneToTwentyFive ? rule.isSearchFeeOneToTwentyFive : "" } </td>
                           <td> {rule.oneThroughTwenty ? rule.oneThroughTwenty : "" } </td>
                           <td> {rule.oneThroughTen ? rule.oneThroughTen : "" } </td>
                           <td> {rule.oneThroughTwentyFive ? rule.oneThroughTwentyFive : "" } </td>
                           <td> {rule.oneThroughThirty ? rule.oneThroughThirty : "" } </td>
                           <td> {rule.oneThroughFourty ? rule.oneThroughFourty : "" } </td>
                           <td> {rule.oneThroughHundred ? rule.oneThroughHundred : "" } </td>
                           <td> {rule.sixAndOver ? rule.sixAndOver : "" } </td>
                           <td> {rule.elevenAndOver ? rule.elevenAndOver : "" } </td>
                           <td> {rule.elevenThroughTwenty ? rule.elevenThroughTwenty : "" } </td>
                           <td> {rule.elevenThroughFourty ? rule.elevenThroughFourty : "" } </td>
                           <td> {rule.elevenThroughFifty ? rule.elevenThroughFifty : "" } </td>
                           <td> {rule.fourteenThroughTwentyFive ? rule.fourteenThroughTwentyFive : "" } </td>
                           <td> {rule.sixteenAndOver ? rule.sixteenAndOver : "" } </td>
                           <td> {rule.twentyOneThroughFifty ? rule.twentyOneThroughFifty : "" } </td>
                           <td> {rule.twentyOneThroughSixty ? rule.twentyOneThroughSixty : "" } </td>
                           <td> {rule.twentyOneThroughHundred ? rule.twentyOneThroughHundred : "" } </td>
                           <td> {rule.twentySixThroughFifty ? rule.twentySixThroughFifty : "" } </td>
                           <td> {rule.twentySixThroughHundred ? rule.twentySixThroughHundred : "" } </td>
                           <td> {rule.twentySixThroughThreeFifty ? rule.twentySixThroughThreeFifty : "" } </td>
                           <td> {rule.twentySixAndOver ? rule.twentySixAndOver : "" } </td>
                           <td> {rule.thirtyOneAndOver ? rule.thirtyOneAndOver : "" } </td>
                           <td> {rule.fourtyOneAndOver ? rule.fourtyOneAndOver : "" } </td>
                           <td> {rule.fiftyOneThroughHundred ? rule.fiftyOneThroughHundred : "" } </td>
                           <td> {rule.fiftyOneAndOver ? rule.fiftyOneAndOver : "" } </td>
                           <td> {rule.sixtyOneAndOver ? rule.sixtyOneAndOver : "" } </td>
                           <td> {rule.hundredAndOneAndOver ? rule.hundredAndOneAndOver : "" } </td>
                           <td> {rule.threeFiftyOneAndOver ? rule.threeFiftyOneAndOver : "" } </td>
                           <td> {rule.regardlessOfAllPages ? rule.regardlessOfAllPages : "" } </td> 
                        </tr>
                       

                  )
               }) : <tr style={{background:"transparent"}}><td colspan="6"><img src="images/no-record-found.png" width="180px" style={{opacity:"0.6"}}/></td></tr>


                }     
       </tbody>
                  </table>
                  </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                  <a href="javascript:void(0)" onClick={this.goBack}>
                  <button type="button" className="btnDefault">Go Back</button>
                  </a>
                </div> 
               </div>
            </div>
         </div>
      </div>
   </div>
   </div>
               
 
         <Footer />


            </>
        )
    }
}

 const mapStateToProps = state => ({
   loginDetails: state.commonReducer.loginDetails,
   getPaymentRulesDetails: state.adminReducer.getPaymentRulesDetails,
   getPaymentRulesStatus : state.adminReducer.getPaymentRulesStatus,

   message: state.commonReducer.message

});
const mapDispatchToProps = dispatch => ({
   getPaymentRules: (token) => dispatch(getPaymentRules(token)),
   savePaymentRule: (rule) => dispatch(savePaymentRule(rule))

});

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(PaymentRules);